export * from './honorar-vereinbarung-entfernt.interface';
